/* This is for the sizing dropdown on the product pages*/

$( ".sizing p:first-child" ).click(function() {

  $( ".sizing" ).toggleClass('hidden');
  $( ".sizing" ).toggleClass('shown');
  
});

$( ".dtail p:first-child" ).click(function() {

  $( ".dtail" ).toggleClass('hidden');
  $( ".dtail" ).toggleClass('shown');
  
});

/* Custom Waypoints goes here*/
var sticky = new Waypoint.Sticky({
  element: $('.header-search-form')[0]
})

var sticky = new Waypoint.Sticky({
  element: $('.header-tools')[0]
})

/*
$(window).load(function() {
if('#scrollslider'){
  $( ".overlaywrap" ).addClass('w-auto');
  $( ".scrollSlider div.viewport div.overview img" ).addClass('w-auto');
}
});

*/
var width = $( window ).width();

if($('#scrollslider').length && (width > 800 )){
	$(window).resize(function(){location.reload();});
}